module.exports = ".mat-dialog-actions {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-pack: distribute;\r\n        justify-content: space-around;\r\n    margin-top: 2rem;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/vehicles/cashout-form-dialog/cashout-form-dialog.component.css
// module id = ./src/app/components/vehicles/cashout-form-dialog/cashout-form-dialog.component.css
// module chunks = main